/**
 * Created by Carsten Bühler
 * User: CBuehler on 22.10.2015
 * Copyright: xdot GmbH 2015
 */

import keyMirror from 'external/keymirror';

export const ClassNames = keyMirror({
    Subscription: null
});

export const Services = {
    Subscription: '/pub_sub.subscription/'
};

export const DataNames = {
    UserSubscriptions: 'userSubscriptions'
};

export const SendChannels = {
    Email: 'email',
    Push: 'push',
    SMS: 'sms'
};



// WEBPACK FOOTER //
// ./js/constants/Constants.js